import {BaseConfig} from "../../infrastructure/config/base-config";
import {PropositionBetsWidgetTerms} from "./proposition-bets-widget.terms";
import {PropositionBetsWidgetRemoteConfig} from "./proposition-bets-widget.remote-config";
import {APP} from "../../core/app/consts";

export class PropositionBetsWidgetConfig extends BaseConfig {
  static injectables = [PropositionBetsWidgetTerms, PropositionBetsWidgetRemoteConfig];

  constructor(terms: PropositionBetsWidgetTerms, remoteConfig: PropositionBetsWidgetRemoteConfig) {
    super('propositionBetsWidget', null, terms, remoteConfig);

    this.source = APP.ANALYTICS.SOURCES.propositionBets;
  }
}
